import { Dialog, DialogContent, Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import Iconify from '../Iconify';
import '../../css/roles/successfulAddRoleDialog.css';

const ActionBox = ({ icon, text, onClick }) => (
    <Box className='SuccessfulAddRole_action_box' onClick={onClick}>
        <Iconify icon={icon} className='SuccessfulAddRole_action_icon' />
        <Typography className='SuccessfulAddRole_action_title'>{text}</Typography>
    </Box>
);

export const SuccessfullAddArticleFolderDialog = ({ openSuccessfulAddArticleFolder, setOpenSuccessfulAddArticleFolder, setOpenAddArticleFolder }) => {

    const { t } = useTranslation();

    const handleOpenAdd = useCallback(() => {
        setOpenSuccessfulAddArticleFolder(false);
        setOpenAddArticleFolder(true);
    }, [setOpenAddArticleFolder, setOpenSuccessfulAddArticleFolder]);

    const handleClose = useCallback(() => {
        setOpenSuccessfulAddArticleFolder(false);
    }, [setOpenSuccessfulAddArticleFolder]);

    return (
        <Dialog open={openSuccessfulAddArticleFolder} onClose={handleClose} classes={{ paper: 'SuccessfulAddRole_dialog' }}>
            <IconButton onClick={handleClose} className='SuccessfulAddRole_icon_button'>
                <Iconify icon={"material-symbols:close"} className='SuccessfulAddRole_close_icon' />
            </IconButton>
            <DialogContent className='SuccessfulAddRole_dialog_content' >
                <Iconify icon={"lets-icons:check-ring-light"} className='SuccessfulAddRole_check_icon' />
                <Typography className='SuccessfulAddRole_message'>{t('AddMachine_validation_message')}</Typography>
                <Box className='SuccessfulAddRole_action_container'>
                    <ActionBox
                        icon={"material-symbols-light:cards-outline"}
                        text={t("List des dossiers d'articles")}
                        onClick={handleClose}
                    />
                    <ActionBox
                        icon={"material-symbols-light:add"}
                        text={t('addArticleFolderDialogTitle')}
                        onClick={handleOpenAdd}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};